import React, { useState, useEffect } from 'react';
import { Image as ImageIcon } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Composant d'image simple - sans thumbnails
 * Charge directement les images originales
 */
export default function OptimizedImage({ 
  src, 
  alt = '', 
  className = '', 
  thumbSize = 'medium', // ignoré maintenant
  showFull = false, // ignoré maintenant
  onClick,
  ...props 
}) {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  // Construire l'URL - SANS paramètre thumb
  const getImageUrl = () => {
    if (!src) return null;
    
    // URL externe - retourner tel quel
    if (src.startsWith('http://') || src.startsWith('https://')) {
      return src;
    }
    
    // URL API locale - ajouter le domaine mais PAS de thumb
    if (src.startsWith('/api/')) {
      return `${API_URL}${src}`;
    }
    
    return src;
  };

  const imageUrl = getImageUrl();

  // Reset state quand src change
  useEffect(() => {
    setError(false);
    setLoaded(false);
  }, [src]);

  if (!src || error) {
    return (
      <div 
        className={`flex items-center justify-center bg-slate-100 ${className}`}
        onClick={onClick}
        {...props}
      >
        <ImageIcon className="w-8 h-8 text-slate-300" />
      </div>
    );
  }

  return (
    <div 
      className={`relative overflow-hidden bg-slate-100 ${className}`}
      onClick={onClick}
      {...props}
    >
      {/* Spinner de chargement */}
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-5 h-5 border-2 border-slate-200 border-t-yellow-500 rounded-full animate-spin" />
        </div>
      )}
      
      <img
        src={imageUrl}
        alt={alt}
        className={`w-full h-full object-cover transition-opacity duration-200 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
      />
    </div>
  );
}
